import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card, Icon } from '@node-space/ui-components'

export interface EarnTotalEarningsProps {
  totalEarnings: string
  allocationEarnings: string
  customerEarnings: string
}

export const EarnTotalEarnings = ({
  totalEarnings,
  allocationEarnings,
  customerEarnings,
}: EarnTotalEarningsProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full borderRadius={12} testId="earn-total-earnings">
      <Box flexCol gap={4}>
        <p className="text-label text-foreground-prominent">{t('earn.myTotalAllTimeEarnings')}</p>

        <h1 className="text-h1 text-foreground-prominent">{totalEarnings}</h1>

        <Box
          flex
          gap={12}
          align="center"
          className="max-sm:flex-col max-sm:items-start max-sm:gap-4"
        >
          <Box flex gap={8} align="center" className="text-foreground-prominent">
            <Icon name="BuildingOffice" size="medium" />
            <p className="text-body-strong">
              {t('earn.fromMyAllocation', { amount: allocationEarnings })}
            </p>
          </Box>

          <Box flex gap={8} align="center" className="text-foreground-prominent">
            <Icon name="UserCircle" size="medium" />
            <p className="text-body-strong">
              {t('earn.fromCustomers', { amount: customerEarnings })}
            </p>
          </Box>
        </Box>
      </Box>
    </Card>
  )
}
